import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getElsparksykkelGebyr } from "../../../actions/elsparksykkelGebyrActions";
import { handleChangeAll as handleChangeAllAction } from "../../../actions/handleChangeAction";
import * as title from "../../../constants/titles";
import {
  getELSIleggelseTableRows,
  getIleggelseQueryParameters,
} from "../../../selectors/ileggelserSelector";
import Utskrift from "../Utskrift";

const ileggelseTableHeaders = [
  "Ilegg.nr.",
  "Ilegg.dato",
  "Klokkeslett",
  "Tjenestenr.",
  "Overt.kode",
  "Kj.merke",
  "Nasjon",
  "Gatenavn",
  "Gatenr.",
  "Bilde",
];

export default function UtskriftContainerELS() {
  const dispatch = useDispatch();
  const ileggelseTableRows = useSelector(getELSIleggelseTableRows);
  const queryParameters = useSelector(getIleggelseQueryParameters);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    document.title = title.ileggelse.ileggelsesoversikt;
    const sessionStoragePrintData = JSON.parse(
      window.sessionStorage.getItem("printData"),
    );
    dispatch(
      handleChangeAllAction(
        "ELSPARKSYKKEL_GEBYR_FILTER_FORM",
        sessionStoragePrintData.queryData,
      ),
    );
    dispatch(
      getElsparksykkelGebyr(
        sessionStoragePrintData.queryData,
        sessionStoragePrintData.paginationData.page,
        sessionStoragePrintData.paginationData.count,
      ),
    ).then(() => {
      setTimeout(() => {
        window.print();
        window.close();
      }, 1000);
    });

    return () => {
      window.sessionStorage.removeItem("printData");
    };
  }, []);

  return (
    <Utskrift
      title="ELS - Ileggelsesoversikt"
      ileggelseTableHeaders={ileggelseTableHeaders}
      ileggelseTableRows={ileggelseTableRows}
      queryParameters={queryParameters}
    />
  );
}
